module.exports = __webpack_public_path__ + "img/birthday-cake.6de5f910.png";